export enum RequesterType {
  PrimaryVI = 'PrimaryVI',
  TeamingVI = 'TeamingVI',
  Endpoint = 'Endpoint',
}
